import { IsInt, Min } from 'class-validator';

export class ChatGetListRequest {
    @IsInt()
    @Min(1)
    public readonly page: number;

    @IsInt()
    @Min(1)
    public readonly limit: number;

    constructor(data?: Partial<ChatGetListRequest>) {
        this.page = data?.page === undefined ? 1 : data.page;
        this.limit = data?.limit === undefined ? 50 : data.limit;
    }
}
